import {
  INDETERMINABLE_ORIGIN_TRIGGERS,
  UNFILTERABLE_TRIGGERS,
} from 'modules/workflows/utils/nodeUtils/fieldsMatchUtils/fieldMatchUtils.constants';

export const isStartTileUnfilterable = (startNodeClass: string) =>
  UNFILTERABLE_TRIGGERS.includes(startNodeClass);
export const isUndeterminableOrigin = (startNodeClass: string) =>
  INDETERMINABLE_ORIGIN_TRIGGERS.includes(startNodeClass);
